import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Image } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  return (
    <Flex align='center' direction='column'>
      <Image 
        src="/logo.png" 
        alt="Logo" 
        h='48px' 
        w='175px' 
        my='32px' 
      />
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
